let appInsightsClient = null;

if (typeof window === "undefined") {
    const appInsights = require("applicationinsights");

    if (process.env.APPLICATIONINSIGHTS_CONNECTION_STRING) {
        appInsights
            .setup(process.env.APPLICATIONINSIGHTS_CONNECTION_STRING)
            .setAutoCollectRequests(true)
            .setAutoCollectPerformance(true)
            .setAutoCollectExceptions(true)
            .setAutoCollectDependencies(true)
            .setAutoDependencyCorrelation(true)
            .setSendLiveMetrics(true)
            .start();

        appInsightsClient = appInsights.defaultClient;
    }
}

export default appInsightsClient;